"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _emotionTheming = require("emotion-theming");

var _eyemobileCore = _interopRequireDefault(require("@bit/eyemobile.core.constants"));

var _IconCircleOutline = _interopRequireDefault(require("./IconCircleOutline"));

var _core = require("@emotion/core");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var ValidationIcon = function ValidationIcon(_ref) {
  var error = _ref.error,
      iconOffset = _ref.iconOffset,
      hasRightIcon = _ref.hasRightIcon;
  var theme = (0, _emotionTheming.useTheme)();

  var rightIconOffset = function rightIconOffset() {
    if (hasRightIcon) {
      return 25;
    }

    return 0;
  };

  var iconPosition = (0, _react.useMemo)(function () {
    return {
      position: 'absolute',
      right: iconOffset + rightIconOffset(),
      top: '50%',
      transform: 'translateY(-50%)',
      width: 24,
      height: 24
    };
  }, [iconOffset, hasRightIcon]);

  if (error) {
    var closeColor = theme && theme.getColor && theme.getColor('error') || _eyemobileCore["default"].error;

    return (0, _core.jsx)("div", {
      style: iconPosition
    }, (0, _core.jsx)(_IconCircleOutline["default"], {
      color: closeColor,
      error: true
    }));
  }

  var checkColor = theme && theme.getColor && theme.getColor('success') || _eyemobileCore["default"].success;

  return (0, _core.jsx)("div", {
    style: iconPosition
  }, (0, _core.jsx)(_IconCircleOutline["default"], {
    color: checkColor
  }));
};

ValidationIcon.defaultProps = {
  error: false,
  iconOffset: 8,
  hasRightIcon: false
};
ValidationIcon.propTypes = {
  error: _propTypes["default"].bool,
  hasRightIcon: _propTypes["default"].bool,
  iconOffset: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number])
};
var _default = ValidationIcon;
exports["default"] = _default;

//# sourceMappingURL=ValidationIcon.js.map